module.exports = __webpack_public_path__ + "img/融创@2x.c5ef6bb8.png";